import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function HomeContentOthers(props) {
    return(
        <div className="logo_content-others">
            <a href={props.link} download={props.link} target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={props.image} />
            </a>
        </div>
    )
}

export default HomeContentOthers